import { render, staticRenderFns } from "./TucowsPromoRequestComponent.vue?vue&type=template&id=4b845b80"
import script from "./TucowsPromoRequestComponent.vue?vue&type=script&lang=js"
export * from "./TucowsPromoRequestComponent.vue?vue&type=script&lang=js"
import style0 from "./TucowsPromoRequestComponent.vue?vue&type=style&index=0&id=4b845b80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports